import { Currency } from '@sigmasms/shared-types';
import { projectName } from './';
const getLocaleByCurrency = (currency) => {
    switch (currency) {
        case Currency.RUB:
        default: return 'ru-RU';
    }
};
export const getCurrencyFromStorage = () => {
    try {
        const item = window.localStorage.getItem(`${projectName}:settings:billings.currency`);
        if (item) {
            return JSON.parse(item);
        }
        else {
            return Currency.RUB;
        }
    }
    catch {
        return Currency.RUB;
    }
};
export const getPrice = (value, params, locale) => {
    const numericValue = typeof value === 'string' ? Number(value) : value;
    if (isNaN(numericValue)) {
        return '';
    }
    const { currency = getCurrencyFromStorage() ?? Currency.RUB, ...restParams } = params ?? {};
    const options = {
        currency,
        style: 'currency',
        currencyDisplay: 'symbol',
        currencySign: 'standard',
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
        ...restParams
    };
    const resolvedLocale = locale ?? getLocaleByCurrency(currency);
    return new Intl.NumberFormat(resolvedLocale, options).format(numericValue);
};
//# sourceMappingURL=currency.js.map